import {
  SignUpMessages,
  TranslationSignUpMessages
} from "../interfaces/signUpMessages";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationSignUpMessages = {
  [SignUpMessages.signUpTitlePage]: "Nuevo usuario",
  [SignUpMessages.signUpEmailLabel]: "E-mail",
  [SignUpMessages.signUpFullNameLabel]: "Nombre completo",
  [SignUpMessages.signUpDocumentLabel]: "Documento",
  [SignUpMessages.signUpRoleLabel]: "Ocupación",
  [SignUpMessages.signUpPhoneNumberLabel]: "Número de teléfono",
  [SignUpMessages.signUpClientName]: "Nombre del cliente",
  [SignUpMessages.signUpClientNameLabel]: "Nombre del cliente (Igual que en el contrato)",
  [SignUpMessages.signUpPasswordLabel]: "Contraseña",
  [SignUpMessages.signUpPasswordConfirmationLabel]:
    "Confirmación de contraseña",
  [SignUpMessages.signUpButton]: "Registrar",
  [SignUpMessages.signUpInvalidEmail]: "E-mail inválido",
  [SignUpMessages.signUpRequiredEmail]: "E-mail obligatorio",
  [SignUpMessages.signUpFullNameRequired]: "Nombre completo obligatorio",
  [SignUpMessages.signUpPasswordRequired]: "Contraseña obligatoria",
  [SignUpMessages.signUpPasswordConfirmationRequired]:
    "Confirmación de contraseña obligatoria",
  [SignUpMessages.signUpPasswordConfirmationMatch]:
    "Las contraseñas no coinciden",
  [SignUpMessages.signUpFailed]:
    "Error al registrarse, verifique sus datos e intente nuevamente"
};
